import { ALLOWED_BILLED_UPON } from '~/types/api/drafts-search';
import { rebuildSetField } from './serviceConditions';
export const BILLING_CADENCES = [
    'weekly',
    'biweekly',
    'monthly',
    'quarterly',
    'yearly'
];
export const BILLING_OCCURRENCES = [
    'onDemand',
    'oneTime',
    'inStages',
    ...BILLING_CADENCES
];
export const BILLING_TRIGGERS = [
    'manual',
    'automatic',
    'partlyAutomatic'
];
const NON_CADENCE_OCCURRENCES = [
    'onDemand',
    'oneTime',
    'inStages'
];
const RECURRING_BILLED_UPON = [
    'ongoing',
    'repeatableManual'
];
const NON_CADENCE_BILLED_UPON = {
    onDemand: [
        'onDemand'
    ],
    oneTime: [
        'oneTimeManual',
        'approval',
        'oneTimeDelivery'
    ],
    inStages: [
        'oneTimeInStages',
        'inStagesManual',
        'inStagesPartlyAutomatic',
        'inStagesAutomatic'
    ]
};
const TRIGGER_BILLED_UPON = {
    manual: [
        'oneTimeManual',
        'repeatableManual',
        'onDemand',
        'inStagesManual'
    ],
    automatic: [
        'ongoing',
        'inStagesAutomatic',
        'approval',
        'oneTimeDelivery'
    ],
    partlyAutomatic: [
        'inStagesPartlyAutomatic'
    ]
};
const isCadence = (occurrence)=>BILLING_CADENCES.includes(occurrence);
const includedValues = (set)=>{
    var _ref, _set_in;
    var _set_nin;
    if (set == null || ((_ref = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return null;
    return (_set_in = set.in) !== null && _set_in !== void 0 ? _set_in : [];
};
const occurrenceBilledUpon = (occurrence)=>isCadence(occurrence) ? RECURRING_BILLED_UPON : NON_CADENCE_BILLED_UPON[occurrence];
const expand = (dimensions, valuesOf)=>dimensions.length === 0 ? ALLOWED_BILLED_UPON : dimensions.flatMap((dimension)=>valuesOf(dimension));
const isUnchangedSelection = (next, current)=>next.length > 0 && next.length === current.length && next.every((value)=>current.includes(value));
const cadencesOf = (predicate, billedUpon)=>{
    var _includedValues;
    const recurrence = (_includedValues = includedValues(predicate.recurrence)) !== null && _includedValues !== void 0 ? _includedValues : [];
    if (recurrence.length > 0) return BILLING_CADENCES.filter((cadence)=>recurrence.includes(cadence));
    return RECURRING_BILLED_UPON.some((value)=>billedUpon.includes(value)) ? [
        ...BILLING_CADENCES
    ] : [];
};
const writeBilling = (predicate, occurrences, triggers, editedDimension)=>{
    var _rebuildSetField;
    const cadences = occurrences.filter(isCadence);
    const everyCadence = cadences.length === BILLING_CADENCES.length;
    const base = (_rebuildSetField = rebuildSetField(predicate, 'recurrence', cadences.length > 0 && !everyCadence ? {
        in: [
            ...cadences
        ]
    } : undefined)) !== null && _rebuildSetField !== void 0 ? _rebuildSetField : {};
    if (occurrences.length === 0 && triggers.length === 0) {
        return rebuildSetField(base, 'billedUpon', undefined);
    }
    const byOccurrence = expand(occurrences, occurrenceBilledUpon);
    const byTrigger = expand(triggers, (trigger)=>TRIGGER_BILLED_UPON[trigger]);
    const combined = ALLOWED_BILLED_UPON.filter((value)=>byOccurrence.includes(value) && byTrigger.includes(value));
    const edited = editedDimension === 'occurrence' ? byOccurrence : byTrigger;
    const kept = combined.length > 0 ? combined : edited;
    return rebuildSetField(base, 'billedUpon', {
        in: [
            ...new Set(kept)
        ]
    });
};
export const selectedBillingOccurrences = (predicate)=>{
    var _ref, _ref1;
    var _predicate_billedUpon_nin, _predicate_billedUpon, _predicate_billedUpon1;
    if (((_ref = (_predicate_billedUpon = predicate.billedUpon) === null || _predicate_billedUpon === void 0 ? void 0 : (_predicate_billedUpon_nin = _predicate_billedUpon.nin) === null || _predicate_billedUpon_nin === void 0 ? void 0 : _predicate_billedUpon_nin.length) !== null && _ref !== void 0 ? _ref : 0) > 0) return [];
    const billedUpon = (_ref1 = (_predicate_billedUpon1 = predicate.billedUpon) === null || _predicate_billedUpon1 === void 0 ? void 0 : _predicate_billedUpon1.in) !== null && _ref1 !== void 0 ? _ref1 : [];
    const nonCadence = NON_CADENCE_OCCURRENCES.filter((occurrence)=>NON_CADENCE_BILLED_UPON[occurrence].some((value)=>billedUpon.includes(value)));
    return [
        ...nonCadence,
        ...cadencesOf(predicate, billedUpon)
    ];
};
export const selectedBillingTriggers = (predicate)=>{
    const billedUpon = includedValues(predicate.billedUpon);
    if (billedUpon == null) return [];
    return BILLING_TRIGGERS.filter((trigger)=>TRIGGER_BILLED_UPON[trigger].some((value)=>billedUpon.includes(value)));
};
export const removeBilling = (predicate)=>{
    var _rebuildSetField;
    const withoutRecurrence = (_rebuildSetField = rebuildSetField(predicate, 'recurrence', undefined)) !== null && _rebuildSetField !== void 0 ? _rebuildSetField : {};
    return rebuildSetField(withoutRecurrence, 'billedUpon', undefined);
};
export const rebuildBillingOccurrences = (predicate, occurrences)=>isUnchangedSelection(occurrences, selectedBillingOccurrences(predicate)) ? predicate : writeBilling(predicate, occurrences, selectedBillingTriggers(predicate), 'occurrence');
export const rebuildBillingTriggers = (predicate, triggers)=>isUnchangedSelection(triggers, selectedBillingTriggers(predicate)) ? predicate : writeBilling(predicate, selectedBillingOccurrences(predicate), triggers, 'trigger');
